export function autoReload(){// 5分毎にリロード
var oneMinute=60000;setTimeout("location.reload()",oneMinute*5);}